import lodashGet from 'lodash/get';
import lodashChunk from 'lodash/chunk';
import Lokijs from 'lokijs';
import lodashZip from 'lodash/zip';
import db_tables from '@/api/data/db_tables';
import { apis, supportLocalIndexedDB } from '@/config';
import { api } from '@/api/api';
import { AbstractDBInterfaceImpl } from './db_abs';
import { util } from '@/api/util';
class ActionStore {
    constructor() {
        this.user = undefined;
        this.lock = undefined;
        this.openedSchemas = {};
        this.filterRegistry = new Map();
    }
}
class DexieDbApiImpl extends AbstractDBInterfaceImpl {
    constructor() {
        super();
        this.accountAction = new Map();
        this.LOCK_KEY_FOR_DB = 'dbWrLock';
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.schemas = {};
        Object.keys(db_tables).forEach(idx => {
            const id = idx;
            if (db_tables[id]) {
                const item = db_tables[id];
                this.schemas[id] = item;
            }
        });
        this.name = apis.dbMemoryApiImpl;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.accountAction.set('global', new ActionStore());
        this.action = new ActionStore();
    }
    close() {
        [...this.accountAction.keys()].forEach(account => {
            Object.keys(this.accountAction.get(account)).forEach(name => {
                this.closeSpecific(name, account);
            });
        });
        [...this.accountAction.values()].forEach(action => {
            var _a;
            (_a = action.lock) === null || _a === void 0 ? void 0 : _a.destroyLock();
        });
    }
    closeSpecific(db, _account = '') {
        var _a;
        let account = this.accountApi.getEmailIdByEmail(_account);
        if ((_a = this.schemas[db]) === null || _a === void 0 ? void 0 : _a.global) {
            account = 'global';
        }
        else if (!_account || !_account.length) {
            account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        }
        if (typeof account === 'string' && account.includes('@')) {
            account = this.systemApi.md5(account, true);
        }
        if (!this.accountAction.has(account)) {
            return;
        }
        const action = this.accountAction.get(account);
        if (Object.prototype.hasOwnProperty.apply(action.openedSchemas, [db]) && action.openedSchemas[db]) {
            action.openedSchemas[db].instance.close();
            delete action.openedSchemas[db];
        }
    }
    init() {
        var _a;
        if (this.systemApi && this.systemApi.getCurrentUser) {
            const currentUser = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.accountMd5) || '';
            if (currentUser) {
                this.accountAction.set(currentUser, new ActionStore());
            }
        }
        return this.name;
    }
    async deleteDB(dbName) {
        console.log('[db.loki]deleteDB', dbName);
        return {
            success: true,
        };
    }
    isMockDB(db) {
        if (!supportLocalIndexedDB() && db.dbName !== 'contact_dexie') {
            return true;
        }
        return false;
    }
    initDb(name, _account = '') {
        var _a;
        if (!(name in this.schemas)) {
            throw new Error('db not defined');
        }
        let account = _account;
        if (typeof account === 'string' && account.includes('@')) {
            account = this.accountApi.getEmailIdByEmail(_account);
            account = this.systemApi.md5(account, true);
        }
        if ((_a = this.schemas[name]) === null || _a === void 0 ? void 0 : _a.global) {
            account = 'global';
        }
        else if (!_account || !_account.length) {
            account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        }
        if (!this.accountAction.has(account)) {
            this.accountAction.set(account, new ActionStore());
        }
        const action = this.accountAction.get(account);
        if (name in action.openedSchemas) {
            return action.openedSchemas[name];
        }
        action.openedSchemas[name] = this.createSchema(this.schemas[name], account);
        return action.openedSchemas[name];
    }
    createSchema(it, _accountMd5 = '') {
        let accountMd5 = _accountMd5;
        if (!(accountMd5 && accountMd5.length) && !it.global) {
            throw new Error('not login');
        }
        if (typeof accountMd5 === 'string' && accountMd5.includes('@')) {
            const standardAccount = this.accountApi.getEmailIdByEmail(_accountMd5);
            accountMd5 = this.systemApi.md5(standardAccount, true);
        }
        const dbName = it.global ? it.name : it.name + '_' + (accountMd5 || new Date().getTime());
        const db = new Lokijs(dbName, {
            autosave: false,
            autoload: false,
            persistenceMethod: 'memory',
        });
        const dbTables = {};
        it.tables.forEach(tb => {
            const indices = [...new Set((tb.index || []).flatMap(item => item.columns))];
            const uniques = tb.primaryKey.columns;
            const collection = db.addCollection(tb.name, {
                unique: uniques,
                indices,
            });
            dbTables[tb.name] = collection;
        });
        return Object.assign(Object.assign({}, it), { instance: db, dbTableController: dbTables });
    }
    afterInit() {
        const user = this.systemApi.getCurrentUser();
        const userMd5 = (user === null || user === void 0 ? void 0 : user.accountMd5) || '';
        this.action.user = user;
        this.action.lock = this.storeApi.getLock(this.LOCK_KEY_FOR_DB);
        if (!this.accountAction.has(userMd5) && userMd5.length > 0) {
            this.accountAction.set(userMd5, new ActionStore());
        }
        return this.name;
    }
    afterLogin() {
        const user = this.systemApi.getCurrentUser();
        const userMd5 = (user === null || user === void 0 ? void 0 : user.accountMd5) || '';
        this.action.user = user;
        this.action.lock = this.storeApi.getLock(this.LOCK_KEY_FOR_DB);
        if (!this.accountAction.has(userMd5) && userMd5.length > 0) {
            this.accountAction.set(userMd5, new ActionStore());
        }
        return this.name;
    }
    beforeLogout() {
        this.close();
        this.action = new ActionStore();
        [...this.accountAction.keys()].forEach(account => {
            this.accountAction.set(account, new ActionStore());
        });
        return this.name;
    }
    tranformQuery2CondtionArray(query) {
        if (!query) {
            return [];
        }
        const conditionArray = [];
        Object.keys(query).forEach(_key => {
            let keys;
            let vals;
            if (_key.startsWith('[')) {
                keys = _key.replace(/[\[\]]/g, '').split('+');
                vals = Array.isArray(query[_key]) ? query[_key] : query[_key].replace(/[\[\]]/g, '').split('+');
            }
            else {
                keys = [_key];
                vals = Array.isArray(query[_key]) ? query[_key] : [query[_key]];
            }
            keys.forEach((it, _index) => {
                conditionArray.push({
                    type: 'equals',
                    field: it,
                    args: [vals[_index]],
                });
            });
        });
        return conditionArray;
    }
    transformCompoundIndex2CondtionArray(query) {
        if (!query || !Array.isArray(query.field)) {
            return [query];
        }
        const { field: oldField, type: oldType, args: oldArgs } = query;
        let totalArgs = [];
        switch (oldType) {
            case 'between': {
                const argBounds = oldArgs.filter(item => Array.isArray(item));
                const argIncludeConfig = oldArgs.filter(item => !Array.isArray(item));
                if (argIncludeConfig.includes(false)) {
                    console.warn('[db.lokijs]switchCompoundIndex.lowerContainer', query);
                }
                totalArgs = lodashZip(argBounds);
                break;
            }
            default: {
                totalArgs = oldArgs;
                break;
            }
        }
        return oldField.map((_field, _fieldIndex) => {
            const argItem = totalArgs[_fieldIndex];
            return {
                type: oldType,
                field: _field,
                args: Array.isArray(argItem) ? argItem : [argItem],
            };
        });
    }
    transformIDBKeyRange(condition) {
        if (!condition || !condition.field) {
            return false;
        }
        const { field } = condition;
        const fileVal = Array.isArray(field) ? field[0] : field;
        const args = Array.isArray(condition.args) ? condition.args.flat() : condition.args;
        switch (condition.type) {
            case 'below':
                return {
                    $field: fileVal,
                    $operator: '$lt',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            case 'belowOrEqual':
                return {
                    $field: fileVal,
                    $operator: '$lte',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            case 'above':
                return {
                    $field: fileVal,
                    $operator: '$gt',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            case 'aboveOrEqual': {
                return {
                    $field: fileVal,
                    $operator: '$gte',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            }
            case 'equals': {
                return {
                    $field: fileVal,
                    $operator: '$eq',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            }
            case 'notEqual': {
                return {
                    $field: fileVal,
                    $operator: '$ne',
                    $val: Array.isArray(args) ? args[0] : args,
                };
            }
            case 'anyOf':
                return {
                    $field: fileVal,
                    $operator: '$in',
                    $val: Array.isArray(args) ? args : [args],
                };
            case 'containsAny':
                return {
                    $field: fileVal,
                    $operator: '$containsAny',
                    $val: Array.isArray(args) ? args : [args],
                };
            case 'startsWith': {
                const args = Array.isArray(condition.args) ? condition.args : [condition.args];
                const regval = lodashGet(args, '[0]', 'unkonwn');
                const regex = new RegExp(`^${regval}`, 'i');
                return {
                    $field: fileVal,
                    $operator: '$regex',
                    $val: regex,
                };
            }
            default: {
                return false;
            }
        }
    }
    tranformLimitOpeartor(query) {
        const txLimitList = [];
        const { filterLimit } = query;
        const count = query.count || (filterLimit ? 10000 : query.count);
        if (count && count > 0) {
            txLimitList.push({
                type: 'limit',
                value: count,
            });
        }
        return txLimitList;
    }
    async getByRangeCondition(query, _account) {
        if (this.isMockDB(query)) {
            return [];
        }
        const dbTable = this.testDbTableNotExist(query, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const adConditionArray = this.transformCompoundIndex2CondtionArray(query.adCondition);
        const txFindList = adConditionArray
            .map(item => this.transformIDBKeyRange(item))
            .filter(item => item !== false)
            .map(item => ({
            type: 'find',
            value: {
                [item.$field]: {
                    [item.$operator]: item.$val,
                },
            },
        }));
        const action = this.accountAction.get('global');
        const _configFilterNames = Array.isArray(query.filter) ? query.filter : [query.filter || 'unknown'];
        const configFilters = _configFilterNames.filter(name => action.filterRegistry.has(name)).map(name => action.filterRegistry.get(name).filterFunc);
        const txWhereList = [];
        if (configFilters.length) {
            txWhereList.push({
                type: 'where',
                value(res) {
                    return configFilters.every(filterFunc => filterFunc(res, query));
                },
            });
        }
        const txList = [...txFindList, ...txWhereList, ...this.tranformLimitOpeartor(query)];
        const results = dbTable.chain(txList).data();
        if (['edm_contact_search', 'contact_search'].includes(query.dbName) && query.tableName === 'contact') {
            return [...new Map(results.map(item => [item.id + ':::' + item.accountName, item])).values()];
        }
        return results;
    }
    getByEqCondition(query, _account) {
        if (this.isMockDB(query)) {
            return Promise.resolve([]);
        }
        const dbTable = this.testDbTableNotExist(query, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const adConditionArray = this.tranformQuery2CondtionArray(query.query).map(_condtionItem => this.transformIDBKeyRange(_condtionItem));
        const txFindList = adConditionArray
            .filter(item => item !== false)
            .map(item => ({
            type: 'find',
            value: {
                [item.$field]: {
                    $eq: item.$val,
                },
            },
        }));
        const action = this.accountAction.get('global');
        const _configFilterNames = Array.isArray(query.filter) ? query.filter : [query.filter || 'unknown'];
        const configFilters = _configFilterNames.filter(name => action.filterRegistry.has(name)).map(name => action.filterRegistry.get(name).filterFunc);
        const txWhereList = [];
        if (configFilters.length) {
            txWhereList.push({
                type: 'where',
                value(res) {
                    return configFilters.every(filterFunc => filterFunc(res, query));
                },
            });
        }
        const txList = [...txFindList, ...txWhereList, ...this.tranformLimitOpeartor(query)];
        return Promise.resolve(dbTable.chain(txList).data());
    }
    async deleteByByRangeCondition(query, _account) {
        if (this.isMockDB(query)) {
            return Promise.resolve(0);
        }
        const dbTable = this.testDbTableNotExist(query, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const operators = this.transformIDBKeyRange(query.adCondition);
        if (!operators) {
            console.warn('[db.loki]getByRangeCondition.unsupport', query);
            return Promise.reject(new Error('请检查查询条件，无法创建查询'));
        }
        dbTable.findAndRemove({
            [operators.$field]: {
                [operators.$operator]: operators.$val,
            },
        });
        return Promise.resolve(0);
    }
    addFilterRegistry(registry) {
        const action = this.accountAction.get('global');
        action.filterRegistry.set(registry.name, registry);
    }
    getTableCount(db, _account) {
        if (this.isMockDB(db)) {
            return Promise.resolve(0);
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        return Promise.resolve(dbTable.count());
    }
    getById(db, id, _account) {
        if (this.isMockDB(db)) {
            return Promise.resolve({});
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        return Promise.resolve(dbTable.find({
            id: {
                $eq: id,
            },
        }));
    }
    async getByIds(db, ids, _account) {
        if (this.isMockDB(db)) {
            return Promise.resolve([]);
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const res = await Promise.all(ids.map(_id => this.getById(db, _id, _account)));
        return Promise.resolve(res);
    }
    async getByIndexIds(db, keyPath, ids, _account) {
        if (this.isMockDB(db)) {
            return Promise.resolve([]);
        }
        console.warn('[db.loki]getByIndexIds.unsupport', db, keyPath, ids);
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        if (Array.isArray(ids) && ids.length > 1) {
            const result = await Promise.all(ids.map(_id => this.getByIndexIds(db, keyPath, [_id], _account)));
            return result.flat();
        }
        return dbTable
            .chain()
            .find({
            [keyPath]: { $eq: ids[0] },
        })
            .data();
    }
    async deleteById(db, id, _account) {
        if (this.isMockDB(db)) {
            return Promise.resolve();
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const idList = util.singleToList(id);
        dbTable.findAndRemove({
            id: {
                $in: idList,
            },
        });
        return Promise.resolve();
    }
    async put(db, items, _account) {
        var _a, _b, _c, _d, _e;
        if (this.isMockDB(db)) {
            return Promise.resolve(items);
        }
        if (!items) {
            return items;
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        try {
            dbTable.insert(items);
            return items;
        }
        catch (ex) {
            const action = this.accountAction.get(this.getDBAccount(db, _account));
            const primaryKey = (_e = (_d = (_c = (_b = (_a = action.openedSchemas) === null || _a === void 0 ? void 0 : _a[db.dbName]) === null || _b === void 0 ? void 0 : _b.dbTableController) === null || _c === void 0 ? void 0 : _c[db.tableName]) === null || _d === void 0 ? void 0 : _d.uniqueNames) === null || _e === void 0 ? void 0 : _e[0];
            if (typeof primaryKey === 'string' && primaryKey.length) {
                dbTable.findAndUpdate({
                    [primaryKey]: {
                        $eq: lodashGet(items, primaryKey),
                    },
                }, _items => (Object.assign(Object.assign({}, _items), { items })));
                return items;
            }
            return items;
        }
    }
    getDBAccount(db, _account) {
        var _a;
        const { _dbAccount } = db;
        let account = _account || _dbAccount;
        if ((_a = this.schemas[db.dbName]) === null || _a === void 0 ? void 0 : _a.global) {
            account = 'global';
        }
        else if (!_account || !_account.length) {
            account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        }
        if (typeof account === 'string' && account.includes('@')) {
            account = this.systemApi.md5(account, true);
        }
        return account;
    }
    async bulkPut(db, _items, _account) {
        var _a, _b, _c, _d, _e;
        if (this.isMockDB(db)) {
            return Promise.resolve(_items);
        }
        if (!Array.isArray(_items) || !_items.length) {
            return _items;
        }
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        const items = _items.map(_item => {
            Reflect.deleteProperty(_item, '$loki');
            return _item;
        });
        if (dbTable.count() === 0) {
            dbTable.insert(items);
            return items;
        }
        const action = this.accountAction.get(this.getDBAccount(db, _account));
        const primaryKey = (_e = (_d = (_c = (_b = (_a = action.openedSchemas) === null || _a === void 0 ? void 0 : _a[db.dbName]) === null || _b === void 0 ? void 0 : _b.dbTableController) === null || _c === void 0 ? void 0 : _c[db.tableName]) === null || _d === void 0 ? void 0 : _d.uniqueNames) === null || _e === void 0 ? void 0 : _e[0];
        const keys = typeof primaryKey === 'string' && primaryKey.length ? _items.map(item => lodashGet(item, primaryKey, '')) : [];
        if (typeof primaryKey === 'string' && primaryKey.length && keys.length) {
            dbTable.findAndRemove({
                [primaryKey]: {
                    $in: keys,
                },
            });
        }
        dbTable.insert(items);
        return items;
    }
    async putAll(db, items, _options, _account) {
        if (!items || items.length === 0) {
            return items;
        }
        const pageSize = lodashGet(_options, 'memoryPageSize') || lodashGet(_options, 'pageSize', DexieDbApiImpl.LokiPutMaxCount);
        try {
            console.log('[daxie_memory_impl] put all start');
            const ret = await (items.length > pageSize ? this.putLargeDataSetToDb(db, items, undefined, _account) : this.bulkPut(db, items, _account));
            console.log(`[daxie_memory_impl] put all finished acount: ${_account}, dbName: ${db.dbName}, tableName: ${db.tableName}, items.length: ${items.length}`);
            return ret;
        }
        catch (ex) {
            this.handleDexieCommonError(db, ex);
            return Promise.reject(ex);
        }
        finally {
            console.log('[daxie_memory_impl] finally db');
        }
    }
    async putLargeDataSetToDb(db, items, _options, _account) {
        const pageSize = lodashGet(_options, 'memoryPageSize') || lodashGet(_options, 'pageSize', DexieDbApiImpl.LokiPutMaxCount);
        const intervalTime = lodashGet(_options, 'memoryIntervalTime') || lodashGet(_options, 'intervalTime', 200);
        const itemParams = lodashChunk(items, pageSize);
        const result = [];
        let requestPromise = Promise.resolve();
        itemParams.forEach((chunkItems, chunkIndex) => {
            requestPromise = requestPromise
                .then(async () => {
                if (chunkIndex !== 0) {
                    await this.dbWait(intervalTime);
                }
                await this.bulkPut(db, chunkItems, _account);
                result.push(...chunkItems);
            })
                .catch(e => {
                console.warn('[db] batch put item error : ', e);
                throw e;
            });
        });
        await requestPromise;
        return result;
    }
    testDbTableNotExist(db, _account) {
        var _a;
        const { _dbAccount, _account: gc_account } = db;
        const standardAccount = this.accountApi.getEmailIdByEmail(_account || '');
        let account = standardAccount || (typeof _dbAccount === 'string' && _dbAccount.length ? _dbAccount : gc_account || '');
        if ((_a = this.schemas[db.dbName]) === null || _a === void 0 ? void 0 : _a.global) {
            account = 'global';
        }
        else if (!account || !account.length) {
            account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        }
        if (typeof account === 'string' && account.includes('@')) {
            account = this.systemApi.md5(account, true);
        }
        if (!this.accountAction.has(account)) {
            this.accountAction.set(account, new ActionStore());
        }
        const action = this.accountAction.get(account);
        const isDbExist = lodashGet(action.openedSchemas, `[${db.dbName}].dbTableController[${db.tableName}].name.length`, 0) !== 0;
        if (!isDbExist) {
            this.initDb(db.dbName, account);
        }
        const dbInstance = action.openedSchemas[db.dbName].dbTableController[db.tableName];
        return dbInstance;
    }
    handleDexieCommonError(db, ex) {
        console.warn('[db] put all data error', db, ex);
    }
    removeAccountAction(emailMD5) {
        if (this.accountAction.has(emailMD5)) {
            this.accountAction.delete(emailMD5);
        }
    }
    clear(db, _account) {
        console.log('[db.loki]clear:', db);
        const dbTable = this.testDbTableNotExist(db, _account);
        if (!dbTable) {
            return Promise.reject(new Error('请检查参数，不存在请求的数据库或表'));
        }
        dbTable === null || dbTable === void 0 ? void 0 : dbTable.findAndRemove();
        return Promise.resolve(true);
    }
    async getTotalDatabaseNames(_) {
        console.log(_);
        return [];
    }
    async getCurrentUserMemoryDB(_account) {
        var _a;
        const account = _account ? lodashGet(this.systemApi.getCurrentUser(_account), 'accountMd5', '') : lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        const dbName = 'contact_search';
        return (_a = this.accountAction.get(account)) === null || _a === void 0 ? void 0 : _a.openedSchemas[dbName].instance;
    }
    async getContactSearchStats(_account) {
        const db = await this.getCurrentUserMemoryDB(_account);
        if (!db) {
            return { totalSizeBytes: 0, tables: [] };
        }
        const tables = db.collections.map(col => {
            const json = JSON.stringify(col.data);
            return {
                name: col.name,
                count: col.data.length,
                sizeBytes: new Blob([json]).size,
            };
        });
        const totalSizeBytes = new Blob([db.serialize()]).size;
        return { totalSizeBytes, tables };
    }
}
DexieDbApiImpl.LokiPutMaxCount = 20000;
const newMemoryApi = new DexieDbApiImpl();
api.registerLogicalApi(newMemoryApi);
export default newMemoryApi;
